import React, { Component } from "react";
import TranslationView from '../Translation/TranslationView';
import ErrorTextViewProps from "./ErrorTextViewProps";
import { FormHelperText } from "@material-ui/core";

export default class ErrorTextView extends Component<ErrorTextViewProps> {

    render() {
        const { error } = this.props;
        
        return (
            <FormHelperText error={!!error}>   
                {error ? TranslationView.translate(error) : " "}
            </FormHelperText>
        );
    }
}